import { t } from "i18next";

import flagAUD from "./assets/img/country_flags/australia.png";
import flagBRL from "./assets/img/country_flags/brazil.png";
import flagBGN from "./assets/img/country_flags/bulgaria.png";
import flagCAD from "./assets/img/country_flags/canada.png";
import flagCNY from "./assets/img/country_flags/china.png";
import flagHRK from "./assets/img/country_flags/croatia.png";
import flagCZK from "./assets/img/country_flags/czech_republic.png";
import flagDKK from "./assets/img/country_flags/denmark.png";
import flagEUR from "./assets/img/country_flags/european_union.png";
import flagXPF from "./assets/img/country_flags/french_polynesia.png";
import flagHKD from "./assets/img/country_flags/hong_kong.png";
import flagHUF from "./assets/img/country_flags/hungary.png";
import flagISK from "./assets/img/country_flags/iceland.png";
import flagINR from "./assets/img/country_flags/india.png";
import flagIDR from "./assets/img/country_flags/indonesia.png";
import flagILS from "./assets/img/country_flags/israel.png";
import flagJPY from "./assets/img/country_flags/japan.png";
import flagMYR from "./assets/img/country_flags/malaysia.png";
import flagMXN from "./assets/img/country_flags/mexico.png";
import flagNZD from "./assets/img/country_flags/new_zealand.png";
import flagNOK from "./assets/img/country_flags/norway.png";
import flagPHP from "./assets/img/country_flags/philippines.png";
import flagPLN from "./assets/img/country_flags/poland.png";
import flagRON from "./assets/img/country_flags/romania.png";
import flagSGD from "./assets/img/country_flags/singapore.png";
import flagZAR from "./assets/img/country_flags/south_africa.png";
import flagKRW from "./assets/img/country_flags/south_korea.png";
import flagSEK from "./assets/img/country_flags/sweden.png";
import flagCHF from "./assets/img/country_flags/switzerland.png";
import flagTHB from "./assets/img/country_flags/thailand.png";
import flagTRY from "./assets/img/country_flags/turkey.png";
import flagGBP from "./assets/img/country_flags/united_kingdom.png";
import flagUSD from "./assets/img/country_flags/united_states.png";

export interface ICurrencyOption {
    name: string;
    code: (typeof currencies)[number]["code"];
    flag: string;
}

const currencies = [
    // 1st element should be EUR (default)
    {
        name: () => t("Currency.EUR"),
        code: "EUR",
        flag: flagEUR,
    },
    {
        name: () => t("Currency.USD"),
        code: "USD",
        flag: flagUSD,
    },
    {
        name: () => t("Currency.JPY"),
        code: "JPY",
        flag: flagJPY,
    },
    {
        name: () => t("Currency.BGN"),
        code: "BGN",
        flag: flagBGN,
    },
    {
        name: () => t("Currency.CZK"),
        code: "CZK",
        flag: flagCZK,
    },
    {
        name: () => t("Currency.DKK"),
        code: "DKK",
        flag: flagDKK,
    },
    {
        name: () => t("Currency.GBP"),
        code: "GBP",
        flag: flagGBP,
    },
    {
        name: () => t("Currency.HUF"),
        code: "HUF",
        flag: flagHUF,
    },
    {
        name: () => t("Currency.PLN"),
        code: "PLN",
        flag: flagPLN,
    },
    {
        name: () => t("Currency.RON"),
        code: "RON",
        flag: flagRON,
    },
    {
        name: () => t("Currency.SEK"),
        code: "SEK",
        flag: flagSEK,
    },
    {
        name: () => t("Currency.CHF"),
        code: "CHF",
        flag: flagCHF,
    },
    {
        name: () => t("Currency.ISK"),
        code: "ISK",
        flag: flagISK,
    },
    {
        name: () => t("Currency.NOK"),
        code: "NOK",
        flag: flagNOK,
    },
    {
        name: () => t("Currency.TRY"),
        code: "TRY",
        flag: flagTRY,
    },
    {
        name: () => t("Currency.AUD"),
        code: "AUD",
        flag: flagAUD,
    },
    {
        name: () => t("Currency.BRL"),
        code: "BRL",
        flag: flagBRL,
    },
    {
        name: () => t("Currency.CAD"),
        code: "CAD",
        flag: flagCAD,
    },
    {
        name: () => t("Currency.CNY"),
        code: "CNY",
        flag: flagCNY,
    },
    {
        name: () => t("Currency.HKD"),
        code: "HKD",
        flag: flagHKD,
    },
    {
        name: () => t("Currency.IDR"),
        code: "IDR",
        flag: flagIDR,
    },
    {
        name: () => t("Currency.ILS"),
        code: "ILS",
        flag: flagILS,
    },
    {
        name: () => t("Currency.INR"),
        code: "INR",
        flag: flagINR,
    },
    {
        name: () => t("Currency.KRW"),
        code: "KRW",
        flag: flagKRW,
    },
    {
        name: () => t("Currency.MXN"),
        code: "MXN",
        flag: flagMXN,
    },
    {
        name: () => t("Currency.MYR"),
        code: "MYR",
        flag: flagMYR,
    },
    {
        name: () => t("Currency.NZD"),
        code: "NZD",
        flag: flagNZD,
    },
    {
        name: () => t("Currency.PHP"),
        code: "PHP",
        flag: flagPHP,
    },
    {
        name: () => t("Currency.SGD"),
        code: "SGD",
        flag: flagSGD,
    },
    {
        name: () => t("Currency.THB"),
        code: "THB",
        flag: flagTHB,
    },
    {
        name: () => t("Currency.ZAR"),
        code: "ZAR",
        flag: flagZAR,
    },
    {
        name: () => t("Currency.XPF"),
        code: "XPF",
        flag: flagXPF,
    },
    {
        name: () => t("Currency.HRK"),
        code: "HRK",
        flag: flagHRK,
    },
] as const;

export const currenciesList = (): ICurrencyOption[] => {
    return currencies.map((c) => ({ ...c, name: c.name() }));
};
